<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    }
  },

}
</script>

<template>
  <div
    class="subsection"
  >
    <div
      v-if="title"
      class="subsection__title"
    >{{ title }}</div>
    <slot/>
  </div>
</template>
